import { Toaster } from "sonner";
import AppRoutes from "./routes/routes";
import { NavigationProgressBar } from "components/NavigationProgressBar";

function App() {
  return (
    <>
    <NavigationProgressBar/>
      <AppRoutes />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#1E3A5f",
            fontSize: "14px",
            borderRadius: "12px",
            padding: "14px 18px",
            fontFamily: "'Inter', sans-serif",
            fontWeight: 500,
          },
          classNames: {
            title: "font-medium",
            description: "text-sm opacity-90",
            icon: "text-[#0B5394]",
            closeButton: "hover:bg-[#D4E8FB]",
          },
          duration: 4000,
        }}
      />
    </>
  )
}

export default App;
